import { css } from "styled-components";

// AST nav icons are a mix of icomoon glyphs (<i>) and inline SVGs, so both are
// recoloured here — CRM only had to cover <i>.
//
// The icon slot is scoped apart from the dropdown arrow deliberately: CRM uses
// two different purples — fg.accent for the arrow, and navIconActive for the
// selected icon artwork it swaps in.
export const containerOnHover = css`
  .nav-icon i,
  .nav-icon svg {
    color: ${({ theme }) => theme.colors.fg.navIcon};
  }

  &:hover,
  &.active {
    background: ${({ theme }) => theme.colors.fg.accent12};
    border-radius: 8px;

    i,
    svg {
      color: ${({ theme }) => theme.colors.fg.accent};
    }

    .nav-icon i,
    .nav-icon svg {
      color: ${({ theme }) => theme.colors.fg.navIconActive};
    }
  }
`;
